import IconButton from '@material-ui/core/IconButton';
import Tooltip from '@material-ui/core/Tooltip';
import ClearIcon from '@material-ui/icons/Clear';
import React, {useCallback, useState} from 'react';
import ConfirmationDialog from '../../ConfirmationDialog';
import {useScheduleContext} from '../Utils/ScheduleContextProvider';

type Props = {
    employeeId : number;
    projectId : number;
};

const RemoveProjectButton : React.FC<Props> = ({employeeId, projectId} : Props) => {
    const scheduleContext = useScheduleContext();
    const [open, setOpen] = useState(false);

    const handleConfirm = useCallback(async () => {
        await scheduleContext.removeProject(employeeId, projectId);
    }, [employeeId, projectId, scheduleContext]);

    return (
        <>
            <Tooltip title="Unlock project and remove all future times">
                <IconButton size="small" onClick={() => setOpen(true)}>
                    <ClearIcon fontSize="inherit"/>
                </IconButton>
            </Tooltip>

            <ConfirmationDialog
                open={open}
                title="Remove Project"
                message="This action will unlock the project and remove all future times."
                onClose={() => setOpen(false)}
                onConfirm={handleConfirm}
            />
        </>
    );
};

export default RemoveProjectButton;
